<template>
  <div>
    <el-dialog
      :visible.sync="show"
      show-cancel-button
      width="450px"
      style="
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.6) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        "
    >
      <div style="margin:20px；width:1200px">
        <div class="headers">
          <p>订货中心店铺数字权益兑换茶资产说明</p>
        </div>

        <div class="main">

          <p style="text-align:justify; text-indent:21pt; "><span style="font-family:宋体; font-size:14pt">用户通过订货中心购买商品获得的店铺数字权益赠送，店铺数字权益可用于该茶企的茶资产兑换，该茶企资产将进行上线交易，店铺数字权益一旦兑换将不再退回。茶资产可用于线上交易也可以在订货商城兑换该茶企任意茶商品。</span></p><p style="text-align:justify; text-indent:21pt; "><span style="font-family:宋体; font-size:14pt">用户在兑换前应对茶资产的风险波动有一定的了解，茶资产上线后会因每天交易的状况有一定的涨幅跌幅波动，一经兑换说明用户已经充分知晓并认可该交易方式和波动风险 。</span></p>

          <div class="btnWrap">
            <!-- <div class="nextStepBtn" @click="goFalse">取消</div> -->
            <div
              class="nextStepBtn sureBtn"
              style="
                    width: 200px;
                    height: 40px;
                    background: #0f40b9;
                    border-radius: 4px;
                    margin: 0 auto;
                  "
              @click="goOk"
            >
              我已阅读
            </div>
          </div></div>

      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    showDia() {
      this.show = true
    },
    goFalse() {
      this.show = false
    },
    goOk() {
      this.show = false
      this.$emit('confirm')
    }
  }
}
</script>
  <style lang="scss" scoped>
  /deep/ .el-dialog {
    background: linear-gradient(
      265deg,
      rgba(255, 255, 255, 0.6) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    background: url("../../../assets/images/1.png") no-repeat;
    background-size: 100% 100%;
    p span{
      color: rgb(19, 18, 149);
    }
    .headers {
      position: relative;
      width: 100%;
      height: 40px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, "PingFang SC";
      font-weight: 600;
      color: #131295;
      line-height: 40px;
      text-align: center;
      margin-bottom:10px;
      p{
        color: #131295;
      }
    }
  }
  .main {
    background: url("../../../assets/images/2.png") no-repeat;
    background-size: 100% 150%;
    height: 300px !important;
    min-height: 300px !important;
    overflow: auto !important;
    padding: 20px 35px;
    p span{
      font-size: 16px !important;
      font-family: PingFangSC-Semibold, "PingFang SC";
      font-weight: 600 !important;
      color: rgba(19, 18, 149, 0.8) !important;
    }
    .title2{
        font-family: 仿宋;
        font-size: 28px !important;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131295;
        position: relative;
        top: -20px;
      margin: 0 10px;
  }
  }
  .main::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
  .main::-webkit-scrollbar-thumb {
    background-color: #D4D4D4;
  }
  .main::-webkit-scrollbar {
    height: 10px;
  }
  .el-dialog {
    height: 90vh;
    margin-top: 5vh;
    overflow: scroll;
  }
  /deep/ .el-dialog__footer {
    display: none;
  }
  .btnWrap {
    display: flex;
    // padding: 20px 20px;
    padding-bottom: 30px;
    padding-top: 30px;

    .nextStepBtn {
      // flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .btnWrap > div:first-child {
    margin-right: 20px;
    color: #fff;
    background-color: transparent;
    // border: 1px solid #979797;
  }
  .sureBtn {
    background-color: #2483ff;
    color: #fff;
  }
  </style>

